import { Action } from "@amzn/ask-legal-domain";

export function extractEmailIdsFromAddresses(addresses: string[]): string[] {
  return addresses.map(email => email.split("@")[0]);
}
export function buildStaticEmailAction(
  subject: string,
  body: string,
  emailAliases: string[],
  defaultDomain: string = "amazon.com"
): {
  action: Action.EmailToStaticRecipients;
  actionType: Action.Type;
} {
  const staticEmails = emailAliases.map(email => {
    return email.includes("@") ? email : `${email}@${defaultDomain}`;
  });

  const action = new Action.EmailToStaticRecipients(
    subject.trim(),
    body.trim(),
    staticEmails
  );

  return {
    action,
    actionType: Action.Type.EmailToStaticRecipients
  };
}

